import React, { use, useEffect } from 'react';
import NavBar from './NavBar';
import '../styles/Header.css';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {

  useEffect(() => {
    const spinner = document.getElementById('spinner');
    if (spinner) {
      spinner.style.display = 'none';
      // Remove the show class to hide the spinner
      spinner.classList.remove('show');
    }
  }, []);
  return (
    <>
      <div id="spinner"
        className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>

      <div className="container-fluid header-top">
        <div className="container d-flex align-items-center">
          <div className="d-flex align-items-center h-100">
            <Link to="/" className="navbar-brand" style={{ height: "70px" }}>
              <img src="img/logo-small.png" alt="Logo" />
            </Link>
          </div>
          <div className="w-100 h-100">
            {/* <div className="topbar px-0 py-2 d-none d-lg-block" style={{ height: "45px" }}>
              <div className="row gx-0 align-items-center">
                <div className="col-lg-8 text-center text-lg-center mb-lg-0">
                  <div className="d-flex flex-wrap">
                    <div className="border-end border-primary pe-3">
                      <a href="inner-page-template.html" className="text-muted small"><i
                        className="fas fa-map-marker-alt text-primary me-2"></i>Find A Location</a>
                    </div>
                    <div className="ps-3">
                      <a href="mailto:example@gmail.com" className="text-muted small"><i
                        className="fas fa-envelope text-primary me-2"></i>info@wassertechnochem.com</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 text-center text-lg-end">
                  <div className="d-flex justify-content-end">
                    <div className="d-flex border-end border-primary pe-3">
                      <a className="btn p-0 text-primary me-3" href="#"><i className="fab fa-facebook-f"></i></a>
                      <a className="btn p-0 text-primary me-3" href="#"><i className="fab fa-twitter"></i></a>
                      <a className="btn p-0 text-primary me-3" href="#"><i className="fab fa-instagram"></i></a>
                      <a className="btn p-0 text-primary me-0" href="#"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <NavBar />

          </div>
        </div>
      </div>

      <div className="modal fade" id="searchModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Search by keyword</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body d-flex align-items-center bg-primary">
              <div className="input-group w-75 mx-auto d-flex">
                <input type="search" className="form-control p-3" placeholder="keywords"
                  aria-describedby="search-icon-1" />
                <span id="search-icon-1" className="btn bg-light border nput-group-text p-3"><i
                  className="fa fa-search"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
<div className='divider-line'></div>
    </>
  );
};

export default Header;
